import Image from 'next/image';
import { RichText } from 'prismic-reactjs';

import { IRecruitmentProcessProps, IStageItem } from './interfaces';
import { imageSerializer } from '../../../utils/imageSerializer';
import {
  Content,
  Description,
  Inner,
  Stage,
  StageIcon,
  Stages,
  Subtitle,
  Title,
  Wrapper,
} from './recruitmentProcess.styles';

export const RecruitmentProcess = ({
  title,
  items,
}: IRecruitmentProcessProps) => {
  return (
    <Wrapper>
      <Inner>
        <Title>{title}</Title>
        <Stages>
          {items.map(
            ({ stage_icon, stage_title, stage_description }: IStageItem) => {
              const title = RichText.asText(stage_title);
              const description = RichText.asText(stage_description);

              return (
                <Stage key={title}>
                  <StageIcon>
                    <Image {...imageSerializer(stage_icon)} />
                  </StageIcon>

                  <Content>
                    <Subtitle>{title}</Subtitle>
                    <Description>{description}</Description>
                  </Content>
                </Stage>
              );
            }
          )}
        </Stages>
      </Inner>
    </Wrapper>
  );
};
